let ControllerName = 'Pages';
const PagesController = Object.freeze({
    PageByCode: `${ControllerName}/page-by-code`,
});

export default PagesController;